import { render, staticRenderFns } from "./HistoryInvocations.vue?vue&type=template&id=1ae927e3"
import script from "./HistoryInvocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryInvocations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports